import React from 'react';

// 0–4 signal strength bars, used for EV-04/EV-05 personal alarms whose
// signal_quality is reported on a 0–4 scale (not the 0–100 score other
// devices use). Filled bars use sage; empty bars are muted.
export function SignalBars({ score, max = 4, testid }) {
  const filled = Math.max(0, Math.min(max, Math.round(Number(score) || 0)));
  return (
    <span className="inline-flex items-end gap-0.5" data-testid={testid} title={`${filled}/${max}`}>
      {Array.from({ length: max }).map((_, i) => (
        <span
          key={i}
          className={`w-1 rounded-sm transition-colors ${i < filled ? 'bg-sage-600' : 'bg-stone_line'}`}
          style={{ height: `${6 + i * 3}px` }}
        />
      ))}
    </span>
  );
}
